<template>
	<div class="equipped">
		<div class="equipped-wrap">
			<div class="equipped-container">
				<div class="header">
					<h1 class="title">{{ $t('equipped.title') }}</h1>
				</div>
				<div class="carousel">
					<div class="carousel-container">
						<div class="carousel-wrap" ref="carouselWrap" :style="{ transform: `translateX(${offset}px)` }">
							<div class="carousel-slides" ref="carousel-slides" v-for="(swiper, index) in swiperList"
								:key="index">
								<div class="swiper">
									<div class="slides-left">
										<div class="header">
											<h1>{{ swiper.name }}</h1>
										</div>
										<div class="slide-inner">
											<div class="inner" v-for="(adg, idx) in swiper.adgList" :key="idx">
												<img src="../../static/img/check.png" alt="">
												<span>{{ $t(`equipped.${adg.cate}.param${idx + 1}` ) }}</span>
											</div>
										</div>
										<div class="slide-btn-wrap">
											<div class="btn shop" @click="onBuy(swiper)" v-if="swiper.url">
												<a
													href="javascript: void 0">{{ swiper.url ? $t('equipped.buy') : $t('available') }}</a>
											</div>
											<div class="btn" @click="navProduct(swiper)">
												<a href="javascript: void 0">{{ $t('equipped.productParame') }}</a>
											</div>
										</div>
									</div>
									<div class="slides-right">
										<img v-lazy="`/res/img/${swiper.src}`" alt="Fail">
									</div>
								</div>
							</div>
						</div>
						<div class="carousel-btn">
							<div class="prev btn" @click="onSwiperPrev" v-show="!isShowBtn">
								<span class="iconfont icon-zuojiantou"></span>
							</div>
							<div class="next btn" @click="onSwiperNext" v-show="!isShowBtn">
								<span class="iconfont icon-youjiantou"></span>
							</div>
						</div>
						<div class="dot">
							<div class="item" :class="i == swiperIndex ? 'active' : ''" v-for="(dot, i) in swiperList"
								:key="i"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<userCommont></userCommont>
	</div>
</template>
<script>
	import userCommont from './component/index.vue'
	let debounce = (func, delay = 200) => {
		let timeoutId;
		return function(...args) {
			clearTimeout(timeoutId)
			timeoutId = setTimeout(() => {
				func.apply(this, args)
			}, delay)
		}
	}

	export default {
		name: 'TVEquipped',
		components: {
			userCommont
		},
		data() {
			return {
				swiperIndex: 0,
				offset: 0,
				isDragging: false,
				touchStartX: 0,
				touchEndX: 0,
				slideWidth: 0,
				swiperList: [{
						name: 'AURORA Elite',
						src: 'carousel-img-1.png',
						url: 'https://auroratvos.com/product/tanix-%d0%bc%d0%b5%d0%b4%d0%b8%d0%b0%d0%bf%d0%bb%d0%b5%d0%b5%d1%80-android-2-%d0%b3%d0%b1-16-%d0%b3%d0%b1-wi-fi-%d0%b8%d0%ba-%d0%bf%d0%be%d1%80%d1%82-irda-%d1%87%d0%b5%d1%80%d0%bd%d1%8b%d0%b9/',
						route: 'auroraElite',
						adgList: [{
								cate: 'elite',
							},
							{
								cate: 'elite',
							},
							{
								cate: 'elite',
							}
						]
					},
					{
						name: 'TANIX W2',
						src: 'carousel-img-2.png',
						url: 'https://auroratvos.com/product/tanix-w2/',
						route: 'tanixw2',
						adgList: [{
								cate: 'tanix',
							},
							{
								cate: 'tanix',
							},
							{
								cate: 'tanix',
							}
						]
					},
					{
						name: 'X96Q',
						src: 'carousel-img-3.png',
						url: 'https://auroratvos.com/product/2131/',
						route: 'x96q',
						adgList: [{
								cate: 'x96q',
							},
							{
								cate: 'x96q',
							},
							{
								cate: 'x96q',
							}
						]
					},
					{
						name: 'AURORA W2',
						src: 'carousel-img-4.png',
						url: '',
						route: 'auroraw2',
						adgList: [{
								cate: 'aurora',
							},
							{
								cate: 'aurora',
							},
							{
								cate: 'aurora',
							}
						]
					}
				],
				isShowBtn: true
			}
		},
		computed: {},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
			if (this.getDeviceType()) {
				const carousel = this.$el.querySelector('.carousel-container')
				carousel.removeEventListener('touchstart', this.handleTouchStart)
				carousel.removeEventListener('touchmove', this.handleTouchMove)
				carousel.removeEventListener('touchend', this.handleTouchEnd)
			}
		},
		mounted() {
			this.isShowBtn = this.getDeviceType()
			// 轮播图相关
			this.calcSlideWidth()
			this.updOffset()
			window.addEventListener('resize', this.handleResize)
			if (this.getDeviceType()) {
				this.bindEvent()
			}
		},
		methods: {
			getDeviceType() {
				const ua = navigator.userAgent
				const isMobile = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
				return isMobile
			},
			calcSlideWidth() {
				if (this.$el && this.$refs['carousel-slides']) {
					this.slideWidth = this.$el.querySelector('.carousel-slides').clientWidth
				}
			},
			bindEvent() {
				const carousel = this.$el.querySelector('.carousel-container')
				carousel.addEventListener('touchstart', this.handleTouchStart, {
					passive: false
				})
				carousel.addEventListener('touchmove', this.handleTouchMove, {
					passive: true
				})
				carousel.addEventListener('touchend', this.handleTouchEnd, {
					passive: true
				})
			},
			handleTouchStart(e) {
				this.touchStartX = e.touches[0].clientX
				this.isDragging = true
				this.startOffset = this.offset
			},
			handleTouchMove(e) {
				if (!this.isDragging) return
				this.touchEndX = e.touches[0].clientX
				const diff = this.touchEndX - this.touchStartX

				// 不调用preventDefault()，但限制滑动范围
				const minOffset = -(this.slideWidth * (this.swiperList.length - 1))
				const maxOffset = 0
				const newOffset = Math.min(maxOffset, Math.max(minOffset, this.startOffset + diff))
				this.offset = newOffset
			},

			handleTouchEnd() {
				this.isDragging = false
				const threshold = this.slideWidth / 4
				const distance = this.touchEndX - this.touchStartX
				if (distance > threshold) {
					this.onSwiperPrev()
				} else if (distance < -threshold) {
					this.onSwiperNext()
				} else {
					// 回弹到当前幻灯片
					this.updOffset()
				}
			},
			updOffset() {
				this.offset = -this.swiperIndex * this.slideWidth
			},
			handleResize: debounce(function() {
				this.calcSlideWidth()
				this.updOffset()
				this.isShowBtn = this.getDeviceType()
			}),
			// 轮播图按钮事件
			onSwiperPrev() {
				if (this.swiperIndex > 0) {
					this.swiperIndex--
					this.updOffset()
				}
			},
			onSwiperNext() {
				if (this.swiperIndex < this.swiperList.length - 1) {
					this.swiperIndex++
					this.updOffset()
				}
			},
			onBuy(product) {
				if (!product.url) {
					// 未上架
					return
				}
				window.open(product.url)
			},
			navProduct(product) {
				this.$router.push(product.route)
				console.log('navProduct', product);
			}
		},
		created() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.btn {
		cursor: pointer;
	}

	.carousel-container {
		border-radius: 16px 16px 0 0;
	}

	@media (max-width: 768px) {

		.equipped-wrap {
			padding: 0 !important;
		}

		.carousel-container {
			border-radius: 16px !important;
		}
	}
</style>